import { Spinner, Text } from '@shopify/polaris';
import './LoadingSpinner.css';

export const LoadingSpinner = (props: { text: string, notInAppBridge?: boolean }) => {
  const { text, notInAppBridge } = props;
  const noAppBridgeClass = notInAppBridge ? ' not-in-app-bridge' : '';

  return (
    <div className={`loading-spinner${noAppBridgeClass}`}>
      <Spinner size="large" />
      {text && (
        <div className={`loading-spinner-text${noAppBridgeClass}`}>
          <Text variant="bodyMd" as="p" color="subdued">{text}...</Text>
        </div>
      )}
    </div>
  );
};
